import { FC } from "react";
import { Block, Box } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import { useTranslation } from "react-i18next";
import { ProductType, CaseStudy } from "../../../models/work";
import { useRouter } from "next/router";
import { CardWrapper } from "./styles";
import Typography from "../../../components/typography";
import Card from "../../../components/views/card";

interface RelatedCaseStudiesProps {
  caseStudies: CaseStudy[];
}

const RelatedCaseStudies: FC<RelatedCaseStudiesProps> = ({ caseStudies }) => {
  const { t, i18n: { language } } = useTranslation();
  const router = useRouter();

  const handleTags = (types: ProductType[]) => types.map((e) => e.name[language]);

  return (
    <Box fDirection="column" mt={3.25} mb={3.25}>
      <Typography
        fSize={{ md: 1.875, xxs: 1.75 }}
        lHeight={{ md: 2.25, xxs: 2.063 }}
        fWeight={700}
        color={colors.black}
        pb={1.75}
      >
        {t("RELATED_CASE_STUDIES")}
      </Typography>
      <CardWrapper
        display='flex'
        margin={{ xs: '0 -1.125rem', xxs: 0 }}
      >
        {
          caseStudies.map((caseStudy, index) =>
            <Block 
              key={index}
              w={{ md: "33.333%", xs: "50%", xxs: "100%" }} 
              padding={{ xs: '0 1.125rem', xxs: 0 }}
              mb={2.25}
            >
              <Card 
                imagePath={caseStudy.image.url}
                title={caseStudy.title && caseStudy.title[language]}
                subtitle={caseStudy.subtitle && caseStudy.subtitle[language]}
                tags={caseStudy?.product_types && caseStudy?.product_types?.length > 0 ? handleTags(caseStudy.product_types) : []}
                onClick={() => router.push(`/work/${caseStudy.url}`)}
              />
            </Block>
          )
        }
      </CardWrapper>
    </Box>
  );
};

export default RelatedCaseStudies;
